import React, {useCallback} from 'react';

function Solutions(props) {
    const {fields, onRemove, onReplace} = props;

    const handleSelect = useCallback(
        e => {
            const {value} = e.target,
                replaceFieldExpr = /^replace-(.*)$/;

            if (value == 'remove') {
                onRemove();
            } else if (value.match(replaceFieldExpr)) {
                let field = value.match(replaceFieldExpr)[1];
                onReplace(field);
            }
        },
        [onRemove, onReplace]
    );

    return (
        <select className="form-control input-sm" value="" onChange={handleSelect}>
            <option value="" disabled>
                Select
            </option>
            <option value="remove">Remove</option>
            <optgroup label="Replace with">
                {fields.map(field => (
                    <option key={field.name} value={`replace-${field.name}`}>
                        {field.label ?? field.name}
                    </option>
                ))}
            </optgroup>
        </select>
    );
}

export default Solutions;
